import React from 'react';

export default function Privacy() {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <span style={styles.logo}><span style={{color:'#fff'}}>Family</span><span style={{color:'#D4A017'}}>Bandhan</span></span>
        </div>
        <h1 style={styles.title}>Privacy Policy</h1>
        <p style={styles.meta}>Effective date: 19 July 2026 · LBLOGIC Solutions (OPC) Private Limited</p>

        <Section title="1. What We Collect (Web Platform)">
          For the web platform, we collect only what is necessary to provide the service: your email address (used as your account identifier and for OTP login), family tree content you choose to add (member names, relations, stories, photos), and subscription status if you upgrade to Premium. We do not collect your name, phone number, address, or any government ID.
        </Section>

        <Section title="1A. What We Collect (FamilyBandhan Desktop)">
          FamilyBandhan Desktop collects nothing. There is no account, no email address, no device identifier, and no activation key of any kind. The application does not connect to the internet or to any FamilyBandhan server at any point during installation or use. All family tree content you create — member names, relationships, stories, and photos — is stored only in a .fmly file on your own device and is never transmitted to us or to anyone else.
        </Section>

        <Section title="2. What We Do Not Collect">
          We do not store your card details, UPI ID, or any payment credentials for the web platform — payments are handled entirely by Razorpay on their secure servers. We do not collect browsing history or location data. For FamilyBandhan Desktop specifically, we do not collect any information at all — no email, no device identifier, no usage data — and we do not access any files, folders, or data on your computer beyond the .fmly file you explicitly open or save.
        </Section>

        <Section title="3. How We Use Your Data">
          Your web platform data is used solely to provide and improve the FamilyBandhan service. We do not sell your data. We do not use your family content for advertising. We do not share your data with third parties except as required by law or to deliver the core service (e.g. cloud storage on Google Cloud Platform, or payment processing via Razorpay for the web platform's Premium subscription). Since FamilyBandhan Desktop collects no data of any kind, this section does not apply to it.
        </Section>

        <Section title="4. Data Storage">
          Web platform data is stored on Google Cloud Platform (GCP) servers located in the asia-south1 region (Mumbai, India). Photos are stored in Google Cloud Storage. Family tree data is stored in Google Firestore. FamilyBandhan Desktop stores nothing on our servers whatsoever — your family tree content exists only in the .fmly file on your own device, which we never receive a copy of.
        </Section>

        <Section title="5. Data Retention">
          Your web platform data is retained for as long as your account is active. If you wish to delete your account and all associated family data, write to support@familybandhan.in and we will process the deletion within 7 business days. FamilyBandhan Desktop has no data retention on our end to describe, since we hold nothing — your family tree content is retained only on your own device for as long as you keep the .fmly file, and can be deleted at any time by deleting that file yourself.
        </Section>

        <Section title="6. Your Rights">
          You have the right to access the data we hold about you, request corrections to inaccurate data, and request deletion of your account and data. This applies to your web platform account. Since FamilyBandhan Desktop holds no data about you, there is nothing for us to access, correct, or delete on that side — you have full and exclusive control over your .fmly file at all times. To exercise your rights regarding the web platform, contact support@familybandhan.in.
        </Section>

        <Section title="7. Children's Privacy">
          FamilyBandhan web accounts are for users aged 18 and above. We do not knowingly collect personal information from minors. Family member records (which may include children) are created and managed by the adult account holder or device owner. FamilyBandhan Desktop, having no account or data collection of any kind, poses no additional privacy exposure for minors beyond the content the device owner chooses to record locally.
        </Section>

        <Section title="8. Cookies and Local Storage">
          FamilyBandhan's web platform uses minimal browser storage (localStorage) only to maintain your login session. We do not use advertising cookies or third-party tracking cookies. FamilyBandhan Desktop is a fully offline application and does not use cookies, browser storage, or any encrypted local storage of any kind — it has nothing to remember about you between sessions other than the .fmly files you choose to save.
        </Section>

        <Section title="9. Changes to This Policy">
          We may update this Privacy Policy from time to time. We will notify you by posting the updated policy on this page with a revised effective date. Continued use of FamilyBandhan or FamilyBandhan Desktop after changes constitutes acceptance of the updated policy.
        </Section>

        <Section title="10. Contact">
          For any privacy-related questions or concerns, about either the web platform or FamilyBandhan Desktop, write to us at support@familybandhan.in. Grievance Officer: LBLOGIC Solutions (OPC) Private Limited, Bengaluru, Karnataka, India.
        </Section>

        <div style={styles.footer}>
          <a href="/" style={styles.link}>← Back to FamilyBandhan</a>
          <span style={styles.sep}>·</span>
          <a href="/terms" style={styles.link}>Terms of Use</a>
          <span style={styles.sep}>·</span>
          <a href="/refund" style={styles.link}>Refund Policy</a>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '24px' }}>
      <h2 style={{ fontSize: '15px', color: '#1a0533', marginBottom: '6px' }}>{title}</h2>
      <p style={{ fontSize: '14px', color: '#4B5563', lineHeight: 1.7, margin: 0 }}>{children}</p>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh', background: '#f8f7ff',
    padding: '32px 16px', fontFamily: "'DM Sans', Arial, sans-serif",
  },
  card: {
    maxWidth: '720px', margin: '0 auto',
    background: '#ffffff', borderRadius: '16px',
    padding: '40px 36px', boxShadow: '0 2px 16px rgba(0,0,0,0.08)',
  },
  header: {
    marginBottom: '24px',
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: '22px', background: '#0e0018',
    padding: '10px 20px', borderRadius: '8px',
    display: 'inline-block',
  },
  logo: { letterSpacing: '0.5px' },
  title: { fontSize: '26px', color: '#1a0533', marginBottom: '4px' },
  meta: { fontSize: '12px', color: '#9CA3AF', marginBottom: '32px' },
  footer: {
    marginTop: '40px', paddingTop: '20px',
    borderTop: '1px solid #E5E7EB',
    display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center',
  },
  link: { fontSize: '13px', color: '#7C3AED', textDecoration: 'none' },
  sep: { color: '#D1D5DB', fontSize: '13px' },
};